import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { NavLink } from 'react-router';
import fileDownload from 'js-file-download';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Alert, Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FileInput from '../../../components/fields/FileInput/FileInput';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';

export default function RegistryImport({
  onClose, handleImport, showSelector = false, title = 'Импорт реестра', type = '',
}) {
  const [file, setFile] = useState(null);
  const [example, setExample] = useState(null);
  const { control, watch } = useForm({ defaultValues: {} });
  const [isWithRelation, setIsWithRelation] = useState(0);

  const exampleFiles = {
    carrier: 'реестр_перевозчиков_для_импорта.xlsx',
    carrier_rel: 'реестр_связок_перевозчик_лт.xlsx',
    szlt: 'реестр_сзлт_для_импорта.xlsx',
    vehicle: 'реестр_лт_для_импорта.xlsx',
  };

  const handleDownloadExample = () => {
    window.open(`/examples/${example}`, '_blank');
  };

  useEffect(() => {
    const f = exampleFiles[type + (isWithRelation ? '_rel' : '')] || '';
    setExample(f);
  }, [isWithRelation, type]);

  return (
    <Dialog
      className="registry-popup-import"
      onClose={onClose}
      size="xl"
      open
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            <div className="hff-title-text f2">{title}</div>
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={onClose} />
            </div>
          </>
        )}
      />
      <DialogContent className="hff-content">
        {showSelector ? (
          <>
            <div className="f4">Выбор типа связей</div>
            <FieldDTO
              control={control}
              component={CustomSelectInput}
              dtoObject={{
                name: 'import',
                labelKey: 'import.register.select',
              }}
              withLabel
              variant="material"
              options={[
                { value: 0, name: 'Импорт реестра Перевозчиков' },
                { value: 1, name: 'Импорт связей Перевозчик-ЛТ' },
              ]}
              inputProps={{
                value: isWithRelation,
                onChange: e => {
                  setIsWithRelation(e.target.value);
                },
              }}
            />
          </>
        ) : null}
        <div className="d-flex flex-row w-100">
          <div className="f4 flex-grow-1">Выберите документ для импорта</div>
          {example ? (
            <div style={{ textAlign: 'right' }}>
              <span className="link" onClick={handleDownloadExample}>Пример файла для импорта</span>
            </div>
          ) : null}
        </div>
        <div className="registry-popup-box-control">
          <FieldDTO
            control={control}
            type="text"
            component={FileInput}
            dtoObject={{
              name: 'file',
            }}
            variant="material"
            label="Выберите фаил для импорта"
            inputProps={{
              onChange: setFile,
            }}
            textMuted="Файл загружать в формате Excel (xlsx), не более 65000 строк"
          />
        </div>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <Button variant="secondary" onClick={onClose}>Отменить</Button>
        <Button onClick={() => {
          onClose();
          handleImport(file, isWithRelation);
        }}
        >Импортировать
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
